/* global Glide */

if (document.querySelector(".testimonial-with-slider-list")) {
    var allSlides = document.querySelectorAll(".glide");
    var allSlidesArray = Array.prototype.slice.call(allSlides);

    allSlidesArray.forEach((slide) => {
        const glide = new Glide(slide, {
            type: "carousel",
            perView: 1, // Display 1 slide per view
            focusAt: 0, // Focus on the first slide
            perTouch: 1,
            autoplay: false,
            accessibility: true,
            startAt: 0,
            rewind: true,
            draggable: true,
            swipeThreshold: 80,
            dragThreshold: 120,
            classes: {
                disabledArrow: "glide__arrow--disabled",
            },
            peek: {
                before: 0,
                after: 0,
            },
            perSwipe: "|",
        });

        const totalSlides = slide.querySelectorAll('.glide__slide').length;

        if (totalSlides > 1) {
            glide.mount();

            // Update progress bar function
            function updateProgress(currentIndex) {
                const progressPercentage = ((currentIndex + 1) / totalSlides) * 100;
                slide.querySelector('.stepper-progress').style.width = progressPercentage + '%';
            }

            glide.on('move.after', function () {
                updateProgress(glide.index);
            });

            // Initialize progress bar
            updateProgress(glide.index);
        } else {
            // Hide progress bar if only one slide
            const progressBar = slide.querySelector('.stepper-container');
            if (progressBar) {
                progressBar.style.display = 'none';
            }
            const glide_controls_div = slide.querySelector('.glide__controls');
            if (glide_controls_div) {
                glide_controls_div.style.display = "none";
            }
        }
    });
}


document.addEventListener("DOMContentLoaded", () => {
    const sliderWrappers = document.querySelectorAll(".testimonial-slider-wrapper.tws-version-four");

    sliderWrappers.forEach((wrapper, index) => {
        const glideEl = wrapper.querySelector(".glide");
        if (!glideEl) return;

        // Initialize a new Glide instance for each slider
        const glide = new Glide(glideEl, {
            type: "carousel",
            perView: 1,
        });

        // Use a unique index element inside each wrapper
        const currentIndexEl = wrapper.querySelector(".current-index");

        if (currentIndexEl) {
            glide.on(["mount.after", "run"], function () {
                const currentIndex = glide.index + 1; // index starts at 0
                currentIndexEl.textContent = currentIndex;
            });
        }

        glide.mount();
    });
});



// document.addEventListener("DOMContentLoaded", () => {
//     const wrappers = document.querySelectorAll(".testimonial-slider-wrapper.tws-version-five");
//     if (!wrappers.length) return;

//     wrappers.forEach((wrapper) => {
//         const cards = wrapper.querySelectorAll(".card");
//         const container = wrapper.querySelector(".carousel-container");

//         if (!container || cards.length === 0) return;

//         let index = 0;
//         let isPointerDown = false;
//         let startX = 0;
//         let lastX = 0;
//         let isDragging = false;

//         const DRAG_THRESHOLD = 8;
//         const SWIPE_THRESHOLD = 50;

//         // Update visible card states
//         function updateCarousel() {
//             cards.forEach((card) => (card.className = "card")); // reset all classes

//             const total = cards.length;
//             const prev1 = (index - 1 + total) % total;
//             const next1 = (index + 1) % total;

//             cards[index].classList.add("active");
//             cards[prev1].classList.add("prev1");
//             cards[next1].classList.add("next1");
//         }

//         function nextCard() {
//             index = (index + 1) % cards.length;
//             updateCarousel();
//         }

//         function prevCard() {
//             index = (index - 1 + cards.length) % cards.length;
//             updateCarousel();
//         }

//         // Click or Keyboard Activation
//         cards.forEach((card, i) => {
//             card.addEventListener("click", (e) => {
//                 if (isDragging) return;
//                 index = i;
//                 updateCarousel();
//             });

//             card.addEventListener("keydown", (e) => {
//                 if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     index = i;
//                     updateCarousel();
//                 }
//             });
//         });

//         container.addEventListener("keydown", (e) => {
//             if (e.key === "ArrowRight") nextCard();
//             if (e.key === "ArrowLeft") prevCard();
//         });

//         // Pointer / Touch Swipe Support
//         container.addEventListener("pointerdown", (e) => {
//             if (!e.isPrimary) return;
//             isPointerDown = true;
//             isDragging = false;
//             startX = e.clientX;
//             lastX = startX;
//             document.body.style.userSelect = "none";
//             container.setPointerCapture?.(e.pointerId);
//         });

//         container.addEventListener("pointermove", (e) => {
//             if (!isPointerDown || !e.isPrimary) return;
//             const dx = e.clientX - startX;
//             if (!isDragging && Math.abs(dx) > DRAG_THRESHOLD) isDragging = true;
//             lastX = e.clientX;
//         });

//         function endPointer(e) {
//             if (!e.isPrimary) return;
//             isPointerDown = false;
//             container.releasePointerCapture?.(e.pointerId);
//             const diff = lastX - startX;

//             if (isDragging && Math.abs(diff) > SWIPE_THRESHOLD) {
//                 diff > 0 ? prevCard() : nextCard();
//             }

//             setTimeout(() => {
//                 isDragging = false;
//             }, 20);
//         }

//         container.addEventListener("pointerup", endPointer);
//         container.addEventListener("pointercancel", endPointer);
//         container.addEventListener("lostpointercapture", endPointer);
//         container.addEventListener("mouseleave", () => {
//             if (isPointerDown) {
//                 isPointerDown = false;
//                 isDragging = false;
//             }
//         });

//         // Accessibility setup
//         container.setAttribute("role", "region");
//         container.setAttribute("aria-label", "Testimonial carousel");
//         container.setAttribute("tabindex", "0");

//         cards.forEach((card, i) => {
//             card.setAttribute("tabindex", "0");
//             card.setAttribute("role", "group");
//             card.setAttribute("aria-roledescription", "slide");
//             card.setAttribute("aria-label", `Slide ${i + 1} of ${cards.length}`);
//         });
//         updateCarousel();
//     });
// });

function ps_testimonialCarousel() {
    const ps_wrappers = document.querySelectorAll(
        ".testimonial-slider-wrapper.tws-version-five"
    );
    if (!ps_wrappers.length) return;

    ps_wrappers.forEach((ps_wrapper) => {
        const ps_container = ps_wrapper.querySelector(".carousel-container");
        const ps_cards = ps_wrapper.querySelectorAll(".card");

        if (!ps_container || !ps_cards.length) return;

        let ps_index = 0;

        /* ---------------------------
           Update carousel state
        ---------------------------- */
        function ps_updateCarousel() {
            ps_cards.forEach((card) => (card.className = "card"));

            const total = ps_cards.length;
            const prev1 = (ps_index - 1 + total) % total;
            const next1 = (ps_index + 1) % total;

            ps_cards[ps_index].classList.add("active");
            ps_cards[prev1].classList.add("prev1");
            ps_cards[next1].classList.add("next1");
        }

        function ps_nextCard() {
            ps_index = (ps_index + 1) % ps_cards.length;
            ps_updateCarousel();
        }

        function ps_prevCard() {
            ps_index = (ps_index - 1 + ps_cards.length) % ps_cards.length;
            ps_updateCarousel();
        }

        /* ---------------------------
           Keyboard support
        ---------------------------- */
        ps_container.addEventListener("keydown", (e) => {
            if (e.key === "ArrowRight") ps_nextCard();
            if (e.key === "ArrowLeft") ps_prevCard();
        });

        /* ---------------------------
           Click support: ANY card → next slide
        ---------------------------- */
        ps_container.addEventListener("click", (e) => {
            const ps_card = e.target.closest(".card");
            if (!ps_card) return;

            // On every click, move to next slide
            ps_nextCard();
        });

        /* ---------------------------
           Accessibility
        ---------------------------- */
        ps_container.setAttribute("role", "region");
        ps_container.setAttribute("tabindex", "0");
        ps_container.setAttribute("aria-label", "Testimonial carousel");

        ps_cards.forEach((card, i) => {
            card.setAttribute("tabindex", "0");
            card.setAttribute("role", "group");
            card.setAttribute("aria-roledescription", "slide");
            card.setAttribute(
                "aria-label",
                `Slide ${i + 1} of ${ps_cards.length}`
            );
        });

        ps_updateCarousel();
    });
}

/* Init */
document.addEventListener("DOMContentLoaded", ps_testimonialCarousel);
